import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: {},
    token: "",
  },
  mutations: {
    setUserInfo(state, userInfo) {
      // 这里的 `state` 对象是模块的局部状态
      state.userInfo = userInfo;
    },
    setToken(state, token) {
      // 这里的 `state` 对象是模块的局部状态
      state.token = token;
    },
    LoginOut(state) {
      state.userInfo = {};
      state.token = "";
      localStorage.clear();
      window.location.reload();
    },
  },
  actions: {},
  getters: {},
});
